module.exports = __webpack_public_path__ + "img/ferrari-20.e62aaa5e.jpg";